/**
 * The Missing Middle journey model for the People Engine.
 *
 * Overlay mapping — each journey stage is driven by one of the four
 * real PE data streams; Navigation is the PE composite itself:
 *   Capability    = C score          (skills vs role requirements)
 *   Visibility    = LEI              (how well learning impact is seen/measured)
 *   Confidence    = Motivation (M)   (drive & belief to apply learning)
 *   Coordination  = Retention (R)    (stable teams working in concert)
 *   Navigation    = PE composite     (readiness to convert capability into value)
 */
export const JOURNEY_STAGES = [
  { key: 'capability', label: 'Capability', driver: 'Capability (C)', metric: 'capability', tab: 'capability', color: '#6366f1', blurb: 'Skills vs role requirements' },
  { key: 'visibility', label: 'Visibility', driver: 'Learning Effectiveness (LEI)', metric: 'lei', tab: 'lei', color: '#8b5cf6', blurb: 'How well learning impact is seen & measured' },
  { key: 'confidence', label: 'Confidence', driver: 'Motivation (M)', metric: 'motivation', tab: 'motivation', color: '#f59e0b', blurb: 'Drive & belief to apply learning' },
  { key: 'coordination', label: 'Coordination', driver: 'Retention (R)', metric: 'retention', tab: 'retention', color: '#10b981', blurb: 'Stable teams working in concert' },
  { key: 'navigation', label: 'Navigation', driver: 'PE Composite', metric: 'pe', tab: null, color: '#0e7490', blurb: 'Readiness to convert capability into value' },
];

// Downstream influence of each journey stage — explains *why* the
// metric matters by showing where its value flows in the chain.
export const STAGE_ATTRIBUTION = {
  capability: [{ stage: 'Visibility', pct: 25 }, { stage: 'Confidence', pct: 30 }, { stage: 'Navigation', pct: 45 }],
  visibility: [{ stage: 'Confidence', pct: 35 }, { stage: 'Coordination', pct: 20 }, { stage: 'Navigation', pct: 45 }],
  confidence: [{ stage: 'Coordination', pct: 35 }, { stage: 'Navigation', pct: 65 }],
  coordination: [{ stage: 'Navigation', pct: 100 }],
  navigation: [{ stage: 'Business Value', pct: 100 }],
};

export const fmtStagePct = (v) => (v == null || Number.isNaN(v) ? '—' : `${Math.round(v * 100)}%`);
